import { Box } from '@mui/material'
import React from 'react'

const Map = () => {
  return (
    <Box>
       <Box
                      sx={{
      
      
                      }}
                  >
                      {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.039061323512!2d78.401827!3d17.411319!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97af368db6f7%3A0x97a97c4fea72646b!2sLuxury%20Real%20Estate%20Consultant%20in%20Hyderabad%20%7C%20Rajiv%20Williams!5e0!3m2!1sen!2sin!4v1744197625673!5m2!1sen!2sin" width="99%" height="450" loading="lazy" ></iframe> */}
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.009773665666!2d78.4018265!3d17.4113186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97af368db6f7%3A0x97a97c4fea72646b!2sLuxury%20Real%20Estate%20Consultant%20in%20Hyderabad%20%7C%20Rajiv%20Williams!5e0!3m2!1sen!2sin!4v1751035150655!5m2!1sen!2sin" width="99%" height="450"   loading="lazy" ></iframe>
                  
                  </Box>
    </Box>
  )
}

export default Map
